import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { currentUrl } from "../../url";

export const transactionApi = createApi({
    reducerPath: "transactionApi",
    tagTypes: ["Transaction", "Balance"],
    baseQuery: fetchBaseQuery({
      baseUrl: currentUrl,
      prepareHeaders: (headers) => {
        // Читаем токен при каждом запросе, чтобы использовать актуальное значение
        const accessToken = localStorage.getItem("accessToken")
        if (accessToken) {
          // Убеждаемся, что токен имеет правильный формат (Bearer префикс)
          const token = accessToken.startsWith("Bearer ") 
            ? accessToken 
            : `Bearer ${accessToken}`
          headers.set("Authorization", token)
          headers.set("Accept", "application/json")
        }
        return headers
      },
    }),
    endpoints: (build) => ({
      getTransactions: build.query({
        query: ({ startDate, endDate, page, perPage, search }) => {
          const params = new URLSearchParams();
          
          if (startDate) params.append('start_date_from', startDate);
          if (endDate) params.append('start_date_to', endDate);
          if (page) params.append('page', page);
          if (perPage) params.append('per_page', perPage);
          if (search) params.append('keyword', search);

          return `/master/search/transactions?${params.toString()}`;
        },
        providesTags: (result) =>
          result
            ? [
                ...result.data.map(({ id }) => ({ type: 'Transaction', id })),
                { type: 'Transaction', id: 'LIST' },
              ]
            : [{ type: 'Transaction', id: 'LIST' }],
      }),
      getBalance: build.query({
        query: () => `/master/balance`,
        providesTags: ["Balance"]
      }),
   
    }),
  })

export const { useGetTransactionsQuery, useGetBalanceQuery } = transactionApi;
